<template>
  <TemplatePreview
    :templateImage="verifiableCredential.image"
    :templateName="verifiableCredential.name"
    :templateLocation="
      verifiableCredential.type === 'Participation'
        ? verifiableCredential?.location?.split(', ')[0] || 'Virtual'
        : null
    "
    :templateStartDate="
      verifiableCredential.type === 'Participation'
        ? verifiableCredential.startDate
        : null
    "
    :templateEndDate="
      verifiableCredential.type === 'Participation'
        ? verifiableCredential.endDate
        : null
    "
    :templateThemeBgColor="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.backgroundCardColor
        : null
    "
    :templateThemeTextColor="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.textColor
        : null
    "
    :templateThemeEffect="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.cardEffect
        : null
    "
    :templateThemeTexture="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.textureImageURL
        : null
    "
    :templateThemeIsLogoBack="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.isLogoBack
        : null
    "
    :templateThemeShape="
      verifiableCredential.badgeTheme
        ? verifiableCredential.badgeTheme.shape
        : null
    "
    :issuerName="
      verifiableCredential.type === 'Community'
        ? verifiableCredential.templateIssuer.name
        : verifiableCredential.issuer.name
    "
    :issuerImage="
      verifiableCredential.type === 'Community'
        ? verifiableCredential.templateIssuer.profileImage
        : verifiableCredential.issuer.profileImage
    "
    :formatSm="false"
    :type="verifiableCredential.type"
    :is3d="true"
  />
</template>

<script>
import { ref, watch, onMounted, inject } from 'vue';
import TemplatePreview from './TemplatePreview.vue';
import TemplateRolePreview from './TemplateRolePreview.vue';
import { useRoute } from 'vue-router';
import { createToast } from 'mosha-vue-toastify';

export default {
  props: {
    vc: Object,
  },
  setup(props) {
    const verifiableCredential = ref(props.vc);
    const api = inject('api');
    const dynamicLink = ref('');
    const qrCodeLink = ref('');
    const isMobile = ref(false);
    const utils = inject('utils');

    const loadAppsFlyerScript = () => {
      return new Promise((resolve, reject) => {
        if (window.AF_SMART_SCRIPT) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src =
          'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js';
        script.async = true;
        script.onload = () => {
          setTimeout(resolve, 100);
        };
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    onMounted(async () => {
      checkMobile();
      try {
        await loadAppsFlyerScript();
      } catch (error) {
        console.error('Erreur lors du chargement du script AppsFlyer:', error);
      }
    });

    return {
      verifiableCredential,
    };
  },

  components: {
    TemplatePreview,
    TemplateRolePreview,
  },
};
</script>
